import { render, staticRenderFns } from "./GoBackButtonRow.vue?vue&type=template&id=9ab8f446&scoped=true&"
import script from "./GoBackButtonRow.vue?vue&type=script&lang=js&"
export * from "./GoBackButtonRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab8f446",
  null
  
)

export default component.exports